<template>
<v-container>
<v-card elevation="11" class=" pa-2" color="secondary" light>
  <v-treeview
            :items="categories"
            activatable
            :multiple-active="false" 
            :active.sync="catactive" 
            return-object
            open-all
            hoverable
            @update:active="selectCat"
            class="font-weight-black textMenu--text"
                        active-class="textMenu font-weight-black black--text"
                        expand-icon="mdi-plus secondary quinty--text ma-3 pa-3">
            <template v-slot:append="{ item }">
              <v-chip small>{{item.qtyprod}}</v-chip>
            </template> 
          ></v-treeview> 
          
</v-card>
</v-container>
</template>

<script>
  export default {
      props:[],
    data () {
      return {
        catactive:[],
           }
    },
    computed:{
      categories(){
        return this.$store.getters.treeviewCatDb
      }
    },
    methods: {
        selectCat(){
          
            this.$emit('changecat',this.catactive[0])
        },
    },
  }
</script>